import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {delay, Observable, of} from 'rxjs';
import {concatMap} from 'rxjs/operators';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'emm-progress-bar',
    styleUrls: ['./progress-bar.component.scss'],
    templateUrl: './progress-bar.component.html',
    standalone: false
})
export class ProgressBarComponent implements OnInit {

    @Input() isLoading$: Observable<any>;
    @Input() width= 100;

    isLoadingWithDelay$: Observable<boolean>;
    constructor() {}

    ngOnInit(): void {
        this.isLoadingWithDelay$ = this.isLoading$
            .pipe(
                concatMap(value => of(value).pipe(delay(500)))
            );

    }

}
